<template>
  <div class="header-bar">
    <sider-trigger :collapsed="collapsed" icon="md-menu" @on-change="handleCollpasedChange"></sider-trigger>
    <modules v-if="userInfo && !userInfo.isAdmin"/>
    <custom-bread-crumb show-icon style="margin-left: 30px;" :list="breadCrumbList"></custom-bread-crumb>
    <div class="custom-content-con">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import siderTrigger from './sider-trigger'
import customBreadCrumb from './custom-bread-crumb'
import Modules from './modules'
import './header-bar.less'
import {mapGetters} from 'vuex'
// import config from '@/config'
export default {
  name: 'HeaderBar',
  components: {
    siderTrigger,
    customBreadCrumb,
    Modules
  },
  props: {
    collapsed: Boolean
  },
  computed: {
    ...mapGetters(['userInfo']),
    breadCrumbList () {
      return this.$store.state.app.breadCrumbList
    }
  },
  methods: {
    handleCollpasedChange (state) {
      this.$emit('on-coll-change', state)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/main/components/header-bar/header-bar.vue